const dashboard_wrapper = {
	otp_not_enabled_dialog: {
		button: "Enable 2FA",
		description:
			"This page requires two-factor authentication (2FA). Please enable it before you proceed.",
		title: "Two-Factor Authentication (2FA) Not Enabled",
	},
	otp_required_dialog: {
		description:
			"This page requires two-factor authentication (2FA). Enter your 2FA code before you proceed.",
		title: "Two-Factor Authentication (2FA) Required!",
	},
	paid_services_disabled: {
		description:
			"They are only available for Companies and Dutch citizens. If you feel this is not apply to you, please let us know. If you are a non Dutch citizen, we might be able to find you a company in your country that delivers our services.",
		title: "Paid services are disabled for you.",
	},
};

export default dashboard_wrapper;
